import React, { useEffect, useState } from 'react';
import { FaSync, FaExternalLinkAlt, FaDownload } from 'react-icons/fa';
import { colors } from '../../employees/styles/personalakteStyles';

type PreviewPaneProps = {
  src?: string | Blob;
  onRefresh?: () => void;
  loading?: boolean;
  height?: number;
};

export function PreviewPane({ src, onRefresh, loading, height }: PreviewPaneProps) {
  const [url, setUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!src) {
      setUrl(undefined);
      return;
    }
    if (src instanceof Blob) {
      const u = URL.createObjectURL(src);
      setUrl(u);
      return () => URL.revokeObjectURL(u);
    } else {
      setUrl(src);
    }
  }, [src]);

  return (
    <div className="preview-pane">
      <div className="toolbar">
        <button
          onClick={onRefresh}
          disabled={loading}
          style={{
            padding: '6px 12px',
            fontSize: 12,
            fontWeight: 600,
            backgroundColor: colors.infoLight,
            color: colors.info,
            border: `1px solid ${colors.info}`,
            borderRadius: 4,
            cursor: loading ? 'wait' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 6,
          }}
          title="Neu laden"
        >
          <FaSync size={12} />
          {loading ? 'Lädt...' : 'Neu laden'}
        </button>
        {url && (
          <>
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                padding: '6px 12px',
                fontSize: 12,
                fontWeight: 600,
                backgroundColor: colors.bgCard,
                color: colors.info,
                border: `1px solid ${colors.info}`,
                borderRadius: 4,
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: 6,
              }}
              title="In neuem Tab öffnen"
            >
              <FaExternalLinkAlt size={12} />
              In neuem Tab
            </a>
            <a
              href={url}
              download
              style={{
                padding: '6px 12px',
                fontSize: 12,
                fontWeight: 600,
                backgroundColor: colors.successLight,
                color: colors.success,
                border: `1px solid ${colors.success}`,
                borderRadius: 4,
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: 6,
              }}
              title="Download"
            >
              <FaDownload size={12} />
              Download
            </a>
          </>
        )}
      </div>
      {url ? (
        <iframe
          className="frame"
          title="contract-preview"
          src={url}
          style={height ? { height: `${height}px` } : undefined}
        />
      ) : (
        <div className="empty" style={height ? { height: `${height}px` } : undefined}>
          <div style={{ fontSize: 14, color: colors.textLight }}>
            {loading ? 'Vorschau wird geladen...' : 'Noch keine Vorschau'}
          </div>
        </div>
      )}
    </div>
  );
}
